<template>
	<div class="main module-dashboard">
		<div class="moduel-dashboard-content">
			<div class="dashboard-info two-columns">
				<div class="dashboard-info-tile">
					<div class="title">Recent POS Sales</div>
					<div v-for="(sale, index) in recentSalesPOS" class="clickable-list-item data-row" @click="goToOrder(sale.order_id)">
						<div>{{ sale.order_number }}</div>
						<div>{{ sale.order_date }}</div>
						<div>{{ sale.full_name }}</div>
						<div class="right">${{ sale.order_total }}</div>
					</div>
				</div>
				<div class="dashboard-info-tile">
					<div class="title">Recent Web Sales</div>
					<div v-for="(sale, index) in recentSalesWeb" class="clickable-list-item data-row" @click="goToOrder(sale.order_id)">
						<div>{{ sale.order_number }}</div>
						<div>{{ sale.order_date }}</div>
						<div>{{ sale.full_name }}</div>
						<div class="right">${{ sale.order_total }}</div>
					</div>
				</div>
			</div>

			<h1 class='dashboard-help-center-heading'>Help Articles</h1>
			<div class="dashboard-help-center">
				<div class="dashboard-help-articles-list">
		        	<div v-for="(item, index) in kbMenu">
			            <div :class="['article-category-link', 'pointer', { 'active-article': kbItemId == item.kb_item_id } ]" @click="getKBItem(item)">{{ item.topic }}</div>
			            <ul>
			                <li :class="['article-link', 'pointer', { 'active-article': kbItemId == subItem.kb_item_id } ]" v-for="(subItem, index) in item.sub_menu" @click="getKBItem(subItem)">{{ subItem.topic }}</li>
			            </ul>
					</div>
				</div>
				<div class="dashboard-article-detail" v-if="kbItem.kb_item_id">
				    <h1>{{ kbItem.topic }}</h1>
				    <div v-html="kbItem.content"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: '',
	data() {
		return {
			loading: false,
			kbMenu: [],
			kbItem: {},
			kbItemId: '',
			loadingArticle: false,
			recentSalesPOS: [],
			recentSalesWeb: []
		}
	},
	created() {
		this.getDashboardStats()
		this.getKBMenu()
	},
	methods: {
		getDashboardStats() {
			this.loading = true
			this.apiCall({ destination: 'get_dashboard_stats_orders' }).then(obj => {
				this.loading = false
				if (obj.status == 'success') {
					this.recentSalesPOS = obj.recent_sales_pos
					this.recentSalesWeb = obj.recent_sales_web
				}
			}).catch(err => {
				console.log(err)
			})
		},
		getKBMenu() {
			this.apiCall({ destination: 'get_kb_menu', data: { parent_item_topic: 'Orders and Sales' } }).then(obj => {
				if (obj.status == 'success') {
					this.kbMenu = obj.kb_menu
					this.getKBItem(this.kbMenu[0])
				}
			}).catch(err => {
				console.log(err)
			})
		},
		getKBItem(item) {
			if (this.loadingArticle || this.kbItemId == item.kb_item_id) { return }
			this.loadingArticle = true
			this.kbItemId = item.kb_item_id
			this.apiCall({ destination: 'get_item_kb_item', data: { kb_item_id: this.kbItemId } }).then(obj => {
				this.loadingArticle = false
				if (obj.status == 'success') {
					this.kbItem = obj.kb_item
				}
			}).catch(err => {
				console.log(err)
			})

		},
		goToOrder(orderId) {
			this.$router.push('/orders-sales/orders/detail/' + orderId)
		}
	}
}
</script>

<style lang="scss" scoped>

</style>
